import styled from "styled-components";

/** 날짜 입력 등을 가로로 배치하는 행. */
export const DateInputDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

/**
 * 모달/폼 하단 버튼 줄.
 * @prop $justify - 정렬 (기본 center)
 * @prop $gap     - 버튼 간격 (기본 20px)
 * @prop $pb      - 하단 패딩 (기본 20px)
 */
export const ButtonBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: ${({ $justify }) => $justify ?? "center"};
  gap: ${({ $gap }) => $gap ?? "20px"};
  padding-bottom: ${({ $pb }) => $pb ?? "20px"};
`;

/** 리스트 상단 요약/액션 바 (검색 결과 수 + 편집 버튼 등). */
export const AlertDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  margin-top: 40px;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.04em;
  text-align: left;
`;
